const InvoiceStatusConstants = {
    DRAFT: 0,
    PUBLISH: 1,
    PAID: 2,
}


export default InvoiceStatusConstants